import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsGeneralReportComponent } from './fields-general-report/fields-general-report.component';
import {FieldsGeneralReportToolbarModule} from './fields-general-report-toolbar/fields-general-report-toolbar.module';
import {TabModule} from '../tab/tab.module';
import {DxListModule, DxLoadPanelModule} from 'devextreme-angular';
import {TimePieChartModule} from '../reports/charts/time-pie-chart/time-pie-chart.module';



@NgModule({
  declarations: [FieldsGeneralReportComponent],
  imports: [
    CommonModule,
    FieldsGeneralReportToolbarModule,
    TabModule,
    DxLoadPanelModule,
    DxListModule,
    TimePieChartModule
  ],
  exports: [FieldsGeneralReportComponent]
})
export class FieldsReportModule { }
